import React, { useState } from "react";
import { createUseStyles } from "react-jss";

export default ({ isSelected, isEnabled }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  const useStyles = createUseStyles({
    thumb: {
      fill: "#cccccc",
      transition: "0.3s",
    },
    thumbHover: { fill: "#353535" },
    circle: {
      transition: "0.3s",
    },
    circlePressed: {
      transform: "scale(1.2)",
    },
    disabled: {
      opacity: "0.5",
    },
  });
  const styles = useStyles();

  return (
    <svg
      onMouseEnter={() => isEnabled && setIsHovering(true)}
      onMouseLeave={() => isEnabled && setIsHovering(false)}
      onMouseDown={() => isEnabled && setIsPressed(true)}
      onMouseUp={() => isEnabled && setIsPressed(false)}
      className={[
        styles.circle,
        isPressed ? styles.circlePressed : "",
        !isEnabled && !isSelected ? styles.disabled : "",
      ].join(" ")}
      width="27"
      height="27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="13.5" cy="13.5" r="13.5" fill="#FFFFFF" />
      <path
        className={[
          styles.thumb,
          isSelected || isHovering ? styles.thumbHover : "",
        ].join(" ")}
        d="M16.2986 6.00456C16.4287 5.98723 16.5242 6.02188 16.6543 6.0652C17.14 6.22981 17.3742 6.74963 17.2268 7.23479C17.0793 7.71129 16.3594 9.86854 16.3594 10.3364C16.3594 10.7955 17.0099 11.2027 17.5304 11.2027L20.1326 11.2027C20.653 11.2027 21 11.5493 21 12.0691C21 12.5889 19.2652 18.1336 19.2652 18.1336C19.1177 18.4715 18.7881 19 18.3978 19L10.4696 19L10.4696 11.2027L12.3259 11.2027C12.6815 10.8475 15.1884 7.12217 15.4312 6.637C15.6134 6.28179 15.9517 6.04788 16.2986 6.00456ZM7 11.2027L8.73482 11.2027L8.73482 19L7 19L7 11.2027Z"
      />
    </svg>
  );
};
